import React, { Component } from "react";
import { style } from "typestyle";
import Throbber from "../../components/Throbber";
import PageLayout from "../../components/PageLayout";
import AlignCenter from "../../components/AlignCenter";
import ListView from "../../components/ListView";
import Jumbotron from "../../components/Jumbotron";
import NavBar from "../../NavBar/NavBar";
import WideButton from "../../components/WideButton";
import PlusCircleIcon from "../../icons/PlusCircle";

import AclCondition from "../../../acl/containers/AclCondition";

import { connect } from "react-redux";
import { Site } from "../../../redux/modules/sites/reducer";
import { getSitesList } from "../../../redux/modules/sites/reducer";
import { getCustomerById } from "../../../redux/modules/customers/reducer";
import { Customer } from "../../../redux/modules/customers/reducer";
import { pushRoute } from "../../../redux/modules/route/actions";
import { initSiteCreationWorkflow } from "../../../redux/modules/workflow/actions";
import { customerHasPermissions } from "../../../acl/utils";
import {
  generate,
  getCurrentCustomerId,
  ROUTE_CUSTOMER_WORKFLOW,
  ROUTE_SITE_DASHBOARD,
} from "../../../redux/modules/route/routes";
import { AclState } from "../../../acl/reducer";
import { GrayDark, White, Blue } from "@traceair/tds";
import { User } from "../../../typings";
import { AppDispatch } from "../../../store";
import { GlobalState } from "../../../redux/modules/rootReducer";
import { userOpensSiteListPage } from "./scenarios";

type Props = {
  pending: boolean;
  customerId: string;
  customer: Customer;
  sites: Site[];
  user: User;
  acl: AclState;
  dispatch: AppDispatch;
};

class SiteList extends Component<Props> {
  componentDidMount() {
    const { customerId, dispatch } = this.props;
    dispatch(userOpensSiteListPage(customerId));
  }

  render() {
    return (
      <PageLayout
        navBar={<NavBar />}
        header={this.renderHeader()}
        content={this.renderContent()}
      />
    );
  }

  renderHeader() {
    // TODO: get sites list from state
    const { sites, customer } = this.props;

    return (
      <Jumbotron
        imageUrl={"logo-company-big.svg"}
        header={(customer && customer.name) || "loading"}
        subheader={(customer && `Sites: ${sites.length}`) || null}
      />
    );
  }

  renderContent() {
    if (this.props.pending) {
      return (
        <AlignCenter>
          <Throbber />
        </AlignCenter>
      );
    }

    return (
      <div>
        {this.renderCreateSiteButton()}
        {this.renderSitesList()}
      </div>
    );
  }

  renderCreateSiteButton() {
    const { customerId, customer, dispatch } = this.props;

    return (
      <AclCondition
        customer={customer}
        permissions={["BACKOFFICE_SITE_CREATION_WORKFLOW_START"]}
      >
        <WideButton
          label="Add site"
          iconComponent={PlusCircleIcon}
          color={White}
          background={Blue}
          onClick={() => {
            dispatch(initSiteCreationWorkflow(customerId)).then(
              ({ id, customerId }) => {
                dispatch(
                  pushRoute(
                    generate(ROUTE_CUSTOMER_WORKFLOW, {
                      customerId,
                      workflowId: id,
                    }),
                  ),
                );
              },
            );
          }}
        />
      </AclCondition>
    );
  }

  renderSitesList() {
    // TODO: get site list from state
    const { acl, sites, customerId, dispatch } = this.props;
    return (
      <ListView
        rows={sites}
        leftColumnHeader="Site name"
        renderLeftColumn={(site: Site) => {
          const viewSiteIdPermitted = customerHasPermissions(
            acl,
            ["BACKOFFICE_SITE_ID_VIEW"],
            customerId,
          );
          return (
            <div>
              <div
                className={style({
                  fontSize: "20px",
                  lineHeight: "26px",
                  opacity: 1,
                })}
              >
                {site.name}
              </div>
              {viewSiteIdPermitted && (
                <div
                  className={style({
                    color: GrayDark,
                    fontSize: "14px",
                    lineHeight: "18px",
                  })}
                >
                  {`${customerId}/${site.id}`}
                </div>
              )}
            </div>
          );
        }}
        onRowClick={site => {
          dispatch(
            pushRoute(
              generate(ROUTE_SITE_DASHBOARD, { customerId, siteId: site.id }),
            ),
          );
        }}
        onSort={rows =>
          rows.sort((a, b) => {
            if (a.name.toLowerCase() === b.name.toLowerCase()) {
              return 0;
            }

            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
          })
        }
      />
    );
  }
}

export default connect((state: GlobalState, ownProps) => {
  const customerId = getCurrentCustomerId(state.route);
  const customer = customerId
    ? getCustomerById(state.customers, customerId)
    : null;

  // TODO: use reducer state getters
  return {
    ...ownProps,
    pending: state.sites.pending,
    sites: customerId && getSitesList(state.sites, customerId),
    customerId,
    customer,
    user: state.user,
    acl: state.acl,
  };
})(SiteList);
